import http from "../../../helpers/http";

/**
 * Faixa "para onde vai o documento" do visualizador de PDF. Prescricao, pedido
 * de exame e documento mandam os tres no mesmo e-mail de fim de atendimento,
 * entao a consulta e o aviso sao os mesmos — so o componente que exibe muda.
 *
 * Exige as props `schedule` e `medicalRecord` e o emit `edit-patient-contact`
 * no componente que usa.
 */
export default {
  data() {
    return {
      documentsDelivery: null,
    };
  },
  methods: {
    loadDocumentsDelivery() {
      http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/documents-delivery`)
          .then((response) => {
            this.documentsDelivery = {...response.data, canEdit: true};
          })
          .catch(() => {
            // Sem a informação a faixa some: melhor não dizer nada do que
            // afirmar um destino que não se confirmou.
            this.documentsDelivery = null;
          });
    },
    openPatientContact() {
      this.$emit('edit-patient-contact');
    },
  },
};
